module.exports = __webpack_public_path__ + "img/ad-2.697dcf96.png";